import type { TypeTag } from '@/types/work/types.work.tag';
import type { TypeBoard } from '@/types/work/types.work.board';
import { workApi } from '@/store/api/work/work.api';
import { shieldTask } from '@/store/api/work/work.local';
import type { TypeAppDispatch } from '@/store/store';
import type { TypeProject } from '@/types/work/types.work.project';
import type { TypeTask } from '@/types/work/types.work.task';
import { current } from '@reduxjs/toolkit';
import { dropById, upsertById } from '@/store/api/base/api.cache';

export const writeTasks = (dispatch: TypeAppDispatch, tasks: TypeTask[], answering?: number): void => {
    if (!tasks?.length) return;
    dispatch(workApi.util.updateQueryData('listTasks', undefined, (draft) => {
        upsertById(draft, tasks.map((task) => {
            const existing = draft.find((item) => item.id === task.id);
            return shieldTask(task, existing ? current(existing) : undefined, answering);
        }));
    }));
};

export const writeProjects = (dispatch: TypeAppDispatch, projects: TypeProject[]): void => {
    if (!projects?.length) return;
    dispatch(workApi.util.updateQueryData('listProjects', undefined, (draft) => { upsertById(draft, projects); }));
};

export const writeBoards = (dispatch: TypeAppDispatch, boards: TypeBoard[]): void => {
    if (!boards?.length) return;
    dispatch(workApi.util.updateQueryData('listBoards', undefined, (draft) => { upsertById(draft, boards); }));
};

export const writeTags = (dispatch: TypeAppDispatch, tags: TypeTag[]): void => {
    if (!tags?.length) return;
    dispatch(workApi.util.updateQueryData('listTags', undefined, (draft) => { upsertById(draft, tags); }));
};

export const dropTag = (dispatch: TypeAppDispatch, id: string): void => {
    dispatch(workApi.util.updateQueryData('listTags', undefined, (draft) => {
        dropById(draft, id);
    }));
};
